// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3Poti","list":"styles_list__3cvdO"};